import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trellisComponents"];
import MarkdownTransitional from './Markdown.transitional';
import MarkdownAlpha from './Markdown.alpha';
import { jsx as _jsx } from "react/jsx-runtime";
const Markdown = _ref => {
  let {
      trellisComponents
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return trellisComponents ? /*#__PURE__*/_jsx(MarkdownAlpha, Object.assign({}, props)) : /*#__PURE__*/_jsx(MarkdownTransitional, Object.assign({}, props));
};
export default Markdown;